import FuseSplashScreen from '@fuse/core/FuseSplashScreen';
import axios from 'api';
import * as userActions from 'app/auth/store/actions';
import jwtService from 'app/services/jwtService';
import * as Actions from 'app/store/actions';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useNavigate } from 'react-router-dom';

const Auth = ({ children }) => {
  const navigate = useNavigate();
  const [loadingCheck, setLoadingCheck] = useState(true);
  const dispatch = useDispatch();
  const { logout, setUserData, showMessage, hideMessage } = bindActionCreators(
    {
      logout: userActions.logoutUser,
      setUserData: userActions.setUserData,
      showMessage: Actions.showMessage,
      hideMessage: Actions.hideMessage
    },
    dispatch
  );

  useEffect(() => {
    Promise.all([
      // Comment the lines which you do not use
      jwtCheck()
    ]).then(() => {
      setLoadingCheck(false);
    });
  }, []);

  const jwtCheck = () => {
    return new Promise(resolve => {
      jwtService.on('onAutoLogin', async () => {
        // this.props.showMessage({ message: 'Logging in with JWT' });

        const hairdressersMe = await axios.get('hairdressers');

        /**
         * Sign in and retrieve user data from Api
         */
        jwtService
          .signInWithToken(navigate)
          .then(user => {
            if (!localStorage.getItem('user')) {
              setUserData({
                user,
                hairdresserSelected:
                  hairdressersMe?.data?.length === 1
                    ? hairdressersMe.data[0]
                    : user.hairdresserSelected
              });
            } else {
              const newUser = {
                ...JSON.parse(localStorage.getItem('user')),
                myGroup: user.myGroup,
                hairdressers: user.hairdressers,
                hairdresserSelected:
                  hairdressersMe?.data?.length === 1
                    ? hairdressersMe.data[0]
                    : null
              };

              setUserData(newUser);
            }
            resolve();
          })
          .catch(error => {
            showMessage({ message: error });

            resolve();
          });
      });

      jwtService.on('onAutoLogout', message => {
        if (message) {
          showMessage({ message });
          children.props.history.push('/login');
        }

        logout();

        resolve();
      });

      jwtService.on('onNoAccessToken', () => {
        resolve();
      });

      jwtService.init();

      return Promise.resolve();
    });
  };

  if (loadingCheck) {
    return <FuseSplashScreen />;
  }

  return children;
};

export default Auth;
